// test665
(665 && 0);
